import { CxEvent } from "@spartacus/core";
import { CUSTOM_USER_EVENT, USER_FORM_STATUS, USER_FORM_TYPE } from "./custom-user.model"

export class CustomUserEvent extends CxEvent {
  static readonly type = 'UserEvent';
  event: CUSTOM_USER_EVENT;
  form_status: USER_FORM_STATUS;
  form_type?: USER_FORM_TYPE;
  register_type?: string;
}
